import React, { useState } from "react";
import '../allcss/appoitment.css';
import appoitment1 from "../Asets/appointment1.jpg";

const Appoitment = () => {
  const [formData, setFormData] = useState({
    guardianName: '',
    guardianEmail: '',
    childName: '',
    mobile: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ success: null, message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[0-9]{10}$/;

    if (formData.guardianName.trim().length < 3) {
      newErrors.guardianName = 'Guardian name must be at least 3 characters';
    }

    if (!emailRegex.test(formData.guardianEmail)) {
      newErrors.guardianEmail = 'Invalid email address';
    }

    if (formData.childName.trim().length < 2) {
      newErrors.childName = 'Child name must be at least 2 characters';
    }

    if (!mobileRegex.test(formData.mobile)) {
      newErrors.mobile = 'Mobile number must be 10 digits';
    }

    if (formData.message.trim().length < 10) {
      newErrors.message = 'Message must be at least 10 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    // Format the message for WhatsApp
    const message = `*Appointment Request*%0A
*Guardian Name:* ${formData.guardianName}%0A
*Guardian Email:* ${formData.guardianEmail}%0A
*Child Name:* ${formData.childName}%0A
*Mobile:* ${formData.mobile}%0A
*Message:* ${formData.message}`;

    const whatsappNumber = '917778851070'; // Don't include the plus sign
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${message}`;

    // Open WhatsApp chat in a new tab
    window.open(whatsappURL, '_blank');

    // Optional UI feedback
    setStatus({ success: true, message: 'Redirecting to WhatsApp...' });
    setFormData({
      guardianName: '',
      guardianEmail: '',
      childName: '',
      mobile: '',
      message: ''
    });
    setErrors({});
  };

  return (
    <div className="appoint-wrap">
      <div className="appoint-box">
        <form className="appoint-form" onSubmit={handleSubmit}>
          <h2>Schedule a School Visit</h2>

          <div className="appoint-row">
            <div className="input-wrap">
              <input
                type="text"
                name="guardianName"
                placeholder="Guardian Name"
                value={formData.guardianName}
                onChange={handleChange}
                required
              />
              {errors.guardianName && <span className="error-text">{errors.guardianName}</span>}
            </div>

            <div className="input-wrap">
              <input
                type="email"
                name="guardianEmail"
                placeholder="Guardian Email"
                value={formData.guardianEmail}
                onChange={handleChange}
                required
              />
              {errors.guardianEmail && <span className="error-text">{errors.guardianEmail}</span>}
            </div>
          </div>

          <div className="appoint-row">
            <div className="input-wrap">
              <input
                type="text"
                name="childName"
                placeholder="Child Name"
                value={formData.childName}
                onChange={handleChange}
                required
              />
              {errors.childName && <span className="error-text">{errors.childName}</span>}
            </div>

            <div className="input-wrap">
              <input
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
              {errors.mobile && <span className="error-text">{errors.mobile}</span>}
            </div>
          </div>

          <div className="input-wrap">
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            {errors.message && <span className="error-text">{errors.message}</span>}
          </div>

          <button type="submit">Book Your Visit</button>

          {status.message && (
            <div className={`appoint-status ${status.success ? 'success' : 'error'}`}>
              {status.message}
            </div>
          )}
        </form>

        <div className="appoint-img">
          <img src={appoitment1} alt="Appointment" />
        </div>
      </div>
    </div>
  );
};

export default Appoitment;
